import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function getPianoPagamentiCorsoStudenti(
  uname,
  token,
  id_corso,
  id_studente
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "getPianoPagamentiCorsoStudenti.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        try {
          var resp = JSON.parse(body.toString());
          if (resp === null) {
            resolve(undefined);
            return;
          }
          // Estrai le info sul corso originale prima di parsare il piano
          var corsoCambiato = resp.corso_cambiato || 0;
          var nomeCorsoOriginale = resp.nome_corso_originale || null;
          var idCorsoOriginale = resp.id_corso_originale || null;

          var piano = JSON.parse(resp.piano);

          // Aggiungi le info sul corso originale al piano
          piano._corsoCambiato = corsoCambiato;
          piano._nomeCorsoOriginale = nomeCorsoOriginale;
          piano._idCorsoOriginale = idCorsoOriginale;

          resolve(piano);
        } catch (e) {
          resolve(undefined);
        }
      });

      res.on("error", function(error) {
        console.error(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id_corso: id_corso,
      id_studente: id_studente,
    });

    req.write(postData);

    req.end();
  });
}
